// =====================================
//
//   FAQ 相關功能 Service
//   Author: Gray
//   createtime: 2016 / 03 / 02
//   updatetime: 2016 / 03 / 02
//
// =====================================
window.InifECShared.factory("FAQService", ['$q', '$http', 'Upload', function($q, $http, Upload) {

    var factory = {};

    // --------------------------------
    // 取得一則FAQ資訊
    // --------------------------------
    var getFAQ = function(faqid) {

        var params = {
            op: "getFAQ",
            faqid: faqid
        },
        cachekey = JSON.stringify(params);

        if(factory.faqCache[cachekey]) {
            return factory.faqCache[cachekey].promise;
        }

        factory.faqCache[cachekey] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/FAQAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.faqCache[cachekey].reject(data.error);
            } else {
                factory.faqCache[cachekey].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.faqCache[cachekey].reject(data);
            console.error("[InifEC Error] : FAQService.getFAQ request error.");
            console.error("status : " + status);
        });

        return factory.faqCache[cachekey].promise;
    }

    // --------------------------------
    // 查詢FAQ
    // --------------------------------
    var getFAQlist = function(keyword, start, len, orderby) {

        var params = {
            op: "getFAQlist",
            keyword: keyword,
            start: start,
            len: len,
            orderby: orderby
        },
        cachekey = JSON.stringify(params);

        if(factory.faqCache[cachekey]) {
            return factory.faqCache[cachekey].promise;
        }

        factory.faqCache[cachekey] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/FAQAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.faqCache[cachekey].reject(data.error);
            } else {
                factory.faqCache[cachekey].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.faqCache[cachekey].reject(data);
            console.error("[InifEC Error] : FAQService.getFAQlist request error.");
            console.error("status : " + status);
        });

        return factory.faqCache[cachekey].promise;
    }

    // --------------------------------
    // 取得產品搜尋總數
    // --------------------------------
    var getFAQlistCount = function(keyword) {

        console.log("++getFAQlistCount", keyword);
        var params = {
            op: "getFAQlistCount",
            keyword: keyword,
        };

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/FAQAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function (data, status, headers, config){
            defer.reject(data);
            console.error("[InifEC Error] : ProductService.getProductInfo request error.");
            console.error("status : " + status);
        });

        return defer.promise;

    };

    // --------------------------------
    // 取得某子分類所有FAQ
    // --------------------------------
    var getSubClassFAQlist = function(subFAQClassId) {

        var params = {
            op: "getSubClassFAQlist",
            subFAQClassId: subFAQClassId
        },
        cachekey = JSON.stringify(params);

        if(factory.faqCache[cachekey]) {
            return factory.faqCache[cachekey].promise;
        }

        factory.faqCache[cachekey] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/FAQAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.faqCache[cachekey].reject(data.error);
            } else {
                factory.faqCache[cachekey].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.faqCache[cachekey].reject(data);
            console.error("[InifEC Error] : FAQService.getSubClassFAQlist request error.");
            console.error("status : " + status);
        });

        return factory.faqCache[cachekey].promise;
    }

    // --------------------------------
    // 取得所有FAQ資訊分類列表
    // --------------------------------
    var getFAQClasslist = function() {

        var params = {
            op: "getFAQClasslist"
        },
        cachekey = JSON.stringify(params);

        if(factory.faqCache[cachekey]) {
            return factory.faqCache[cachekey].promise;
        }

        factory.faqCache[cachekey] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/FAQAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.faqCache[cachekey].reject(data.error);
            } else {
                factory.faqCache[cachekey].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.faqCache[cachekey].reject(data);
            console.error("[InifEC Error] : FAQService.getFAQClasslist request error.");
            console.error("status : " + status);
        });

        return factory.faqCache[cachekey].promise;
    }

    // --------------------------------
    // 隨機拿幾筆FAQ
    // --------------------------------
    var getFAQListByRandom = function(len) {

        var params = {
            op: "getFAQListByRandom",
            len: len
        };

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/FAQAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }            
        }).error(function (data, status, headers, config){
            defer.reject(data);
            console.error("[InifEC Error] : FAQService.getFAQListByRandom request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    var setMainFAQList = function(mainFAQList) {

        factory.mainFAQList = mainFAQList;
    }

    var getMainFAQList = function() {

        return factory.mainFAQList;
    }

    // --------------------------------
    // 拿前幾筆置頂的FAQ
    // --------------------------------
    var getFAQListByStickytime = function(len) {

        var params = {
            op: "getFAQListByStickytime",
            len: len
        },

        cachekey = JSON.stringify(params);

        if(factory.faqCache[cachekey]) {
            return factory.faqCache[cachekey].promise;
        }

        factory.faqCache[cachekey] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/FAQAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.faqCache[cachekey].reject(data.error);
            } else {
                factory.faqCache[cachekey].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.faqCache[cachekey].reject(data);
            console.error("[InifEC Error] : FAQService.getFAQListByStickytime request error.");
            console.error("status : " + status);
        });

        return factory.faqCache[cachekey].promise;
    }

    /*==========================
        Members
    ==========================*/
    factory.faqCache = {};
    factory.mainFAQList = [];

    /*==========================
        Methods
    ==========================*/
    factory.getFAQ = getFAQ; // 取得一則FAQ資訊
    factory.getFAQlist = getFAQlist; // 查詢FAQ
    factory.getFAQlistCount = getFAQlistCount; // 取得查詢FAQ總數
    factory.getSubClassFAQlist = getSubClassFAQlist; // 取得某子分類所有FAQ
    factory.getFAQClasslist = getFAQClasslist; // 取得所有FAQ資訊分類列表
    factory.getFAQListByRandom = getFAQListByRandom; // 隨機拿幾筆FAQ
    factory.setMainFAQList = setMainFAQList;
    factory.getMainFAQList = getMainFAQList;
    factory.getFAQListByStickytime = getFAQListByStickytime; // 拿前幾筆置頂的FAQ

    return factory;
}]);